// 运营平台请求
import axios from 'axios'
import { Notification } from 'element-ui'
import router from '.././router/lazy'
import { getMessage } from '@/utils/commonUtils'
const service = axios.create({
  baseURL: window.XCConfig.OMS_API,
  timeout: 30000,
  withCredentials: true
})

service.interceptors.request.use(config => {
  // if (store.getters.token) {
  //   config.headers['Authorization'] = 'Bearer' + getToken()
  // }
  config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  return config
}, error => {
  Promise.reject(error)
})

service.interceptors.response.use(
  response => {
    if (response.data.code === 0) {
      // Notification.success({
      //   title: '信息',
      //   message: response.data.message
      // })
      return response
    } else if (response.data.code === 1) {
      // 未登录
      Notification.error({
        title: '未登录',
        message: '没有登录，或没有进行认证'
      })
      let historyPath = router.currentRoute.path
      if (historyPath !== '/' && historyPath !== '/dashboard/workplace' && historyPath !== '/login') {
        sessionStorage.setItem('historyPath', historyPath)
      }
      router.replace({path: '/login'})
      return Promise.reject(response)
    } else if (response.data.code === 2) {
      Notification.error({
        title: '数据验证失败',
        message: getMessage(response.data.code, response.data.errMsg)
      })
      return Promise.reject(response)
    } else if (response.data.code === 3) {
      if (response.data.businessErrorKey === 'passwordTokenError' || response.data.businessErrorKey === 'decryptFailure') {
        sessionStorage.removeItem('loginName')
        sessionStorage.removeItem('passwordToken')
        Notification.error({
          title: 'passwordTokenError',
          message: '记住密码已过期, 请重新输入密码'
        })
        return Promise.reject(response)
      } else if (response.data.businessErrorKey === 'firstLogin') {
        Notification.error({
          title: '第一次登陆请修改密码',
          message: response.data.message
        })
        return Promise.reject(response)
      } else if (response.data.businessErrorKey === 'passwordIsTooSimple') {
        Notification.error({
          title: '密码太简单，请修改密码',
          message: getMessage(response.data.code, response.data.errMsg)
        })
        return Promise.reject(response)
      } else if (response.data.businessErrorKey === 'tenantInexistence') {
        Notification.error({
          title: '用户不存在',
          message: response.data.message
        })
        sessionStorage.removeItem('passwordToken')
        return Promise.reject(response)
      } else {
        Notification.error({
          title: '业务操作异常',
          message: response.data.message
        })
        return Promise.reject(response)
      }
    } else if (response.data.code === 4) {
      Notification.error({
        title: '没有操作权限',
        message: response.data.message
      })
      return Promise.reject(response)
    } else if (response.data.code === 5) {
      Notification.error({
        title: '数据操作异常',
        message: response.data.message
      })
      return Promise.reject(response)
    } else if (response.data.code === 6) {
      Notification.error({
        title: '显示层异常',
        message: response.data.message
      })
      return Promise.reject(response)
    } else if (response.data.code === 7) {
      Notification.error({
        title: '授权码非法',
        message: response.data.message
      })
      return Promise.reject(response)
    } else if (response.data.code === 127) {
      Notification.error({
        title: '系统错误！！！',
        message: response.data.message
      })
      return Promise.reject(response)
    } else {
      Notification.error({
        title: '错误',
        message: response.data.message
      })
      return Promise.reject(response)
    }
  },
  error => {
    Notification.error({
      title: '错误',
      message: '服务器错误'
    })
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/oms_request.js